import { makeStyles } from "@material-ui/styles";

export const useStyles = makeStyles({
  container: {
    position: "sticky",
    top: "0",
    left: "0",
    zIndex: "10",
    display: "flex",
    alignItems: "center",
    padding: "1rem",
    minHeight: "4rem",
    width: "100%",
    backgroundColor: (themeColor) => themeColor.primary,
    "& img": {
      height: "1.825rem",
      cursor: "pointer",
      marginRight: "1rem",
    },
    "& h1": {
      color: "#fff",
      fontSize: "1.5rem",
      fontWeight: "500",
    },
  },
});